import React from "react";
import NuevoNegocio from "../NuevoNegocio";
import { withRouter } from "react-router";
const EditarInformacion = props => {
  return <NuevoNegocio edit={true} id={props.match.params.id} />;
};
export default withRouter(EditarInformacion);
